import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-help-chat-reset-dialog',
  imports: [MatButtonModule, MatDialogModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ 'Help_chat_reset_title_tr' | translate }}</h2>
    <mat-dialog-content>
      {{ 'Help_chat_reset_message_tr' | translate }}
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button type="button" mat-button mat-dialog-close>{{ 'Help_chat_cancel_tr' | translate }}</button>
      <button type="button" mat-flat-button class="confirm-reset-button" [mat-dialog-close]="true">{{ 'Help_chat_reset_confirm_tr' | translate }}</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .confirm-reset-button {
      background: #e05c40;
      color: #fff;
    }
    .confirm-reset-button:hover { background: #dd5237; }
  `],
})
export class HelpChatResetDialogComponent {}
